module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-snackbar', {
    attrs: {
      "color": "green lighten-1",
      "absolute": "absolute"
    },
    model: {
      value: (_vm.success),
      callback: function($$v) {
        _vm.success = $$v
      },
      expression: "success"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('v-snackbar', {
    attrs: {
      "color": "red lighten-1",
      "absolute": "absolute"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('v-dialog', {
    attrs: {
      "width": "700",
      "persistent": "persistent",
      "app": "app",
      "absolute": "absolute"
    },
    model: {
      value: (_vm.reserveVehicle.open),
      callback: function($$v) {
        _vm.$set(_vm.reserveVehicle, "open", $$v)
      },
      expression: "reserveVehicle.open"
    }
  }, [_c('v-card', [_c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "pl-2 pr-2",
    staticStyle: {
      "height": "20px",
      "display": "flex",
      "flex-direction": "row, align-items: center",
      "justify-content": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "small",
      "flat": "flat",
      "icon": "icon"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("book")])], 1), _c('h5', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Reserva de Veículo")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "small",
      "outline": "outline",
      "color": "red lighten-3"
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('CHANGE_VISIBILITY', _vm.resetaDados = null)
      }
    }
  }, [_c('span', {
    staticClass: "red--text"
  }, [_vm._v("fechar")])])], 1), _c('v-divider')], 1), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "flex-wrap": "wrap"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "xs4"
    }
  }, [_c('div', {
    staticClass: "ml-2 mr-1 pa-2 elevation-0",
    staticStyle: {
      "border-radius": "4px",
      "border": "1px solid #090",
      "background-color": "#f2f2f2"
    },
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "centraliza"
  }, [_c('v-icon', [_vm._v("person")]), (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? false : true) ? _c('h5', {
    staticClass: "text-xs-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm.user.userName))]) : _vm._e(), (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? true : false) ? _c('h5', {
    staticClass: "text-xs-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm.reserveVehicle.veiculoSelecionado.user_reserva))]) : _vm._e()], 1)])], 1)]), _c('v-flex', {
    attrs: {
      "xs4": "xs4"
    }
  }, [_c('div', {
    staticClass: "ml-2 mr-1 pa-2 elevation-0",
    staticStyle: {
      "border-radius": "4px",
      "border": "1px solid #090",
      "background-color": "#f2f2f2"
    },
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "centraliza"
  }, [_c('v-icon', [_vm._v("date_range")]), _c('h5', {
    staticClass: "text-xs-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("dataReserva")(_vm.reserveVehicle.veiculoSelecionado.data_reserva)))])], 1)])], 1)]), _c('v-flex', {
    attrs: {
      "xs4": "xs4"
    }
  }, [_c('div', {
    staticClass: "ml-2 mr-1 pa-2 elevation-0",
    staticStyle: {
      "border-radius": "4px",
      "background-color": "#f2f2f2"
    },
    style: (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? 'border: 1px solid #900' : 'border-left: 1px solid #090'),
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "centraliza"
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? 'red lighten-2' : 'green'
    }
  }, [_vm._v("bookmark")]), _c('h5', {
    staticClass: "text-xs-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("status")(_vm.reserveVehicle.veiculoSelecionado.state_id)))])], 1)])], 1)]), _c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('v-divider')], 1), _c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [(_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? false : true) ? _c('v-textarea', {
    staticClass: "ma-2",
    attrs: {
      "box": "box",
      "color": "green"
    },
    model: {
      value: (_vm.observacoes),
      callback: function($$v) {
        _vm.observacoes = $$v
      },
      expression: "observacoes"
    }
  }) : _vm._e(), (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? true : false) ? _c('v-textarea', {
    staticClass: "ma-2",
    attrs: {
      "disabled": "disabled",
      "box": "box",
      "color": "green"
    },
    model: {
      value: (_vm.reserveVehicle.reserva.observacoes),
      callback: function($$v) {
        _vm.$set(_vm.reserveVehicle.reserva, "observacoes", $$v)
      },
      expression: "reserveVehicle.reserva.observacoes"
    }
  }) : _vm._e()], 1), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "xs12"
    }
  }, [(_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? true : false) ? _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "red lighten-2"
    },
    on: {
      "click": function($event) {
        return _vm.cancelaReserva(_vm.reserveVehicle, _vm.user)
      }
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Cancelar Reserva")]), _c('v-icon', {
    staticClass: "mb-1 mt-1 ml-2",
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")]), (_vm.carregando) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "indeterminate",
      "size": "20"
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? false : true) ? _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.montaReserva(_vm.reserveVehicle)
      }
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Reservar Veículo")]), _c('v-icon', {
    staticClass: "mb-1 mt-1 ml-2",
    attrs: {
      "color": "white"
    }
  }, [_vm._v("check")]), (_vm.carregando) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "indeterminate",
      "size": "20"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3715de"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reserva.vue
// module id = 994
// module chunks = 1